import React from 'react';

export const Id = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const EmployeeName = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const EmployeeId = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Amount = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Type = ({ value }) => {
  return <span>{value || ''}</span>;
};
